import { Quote, Star } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const TESTIMONIALS = [
  {
    name: "R. K Dass",
    company: "Founder & Director, ABM Polytechnic, Andaman & Nicobar Islands",
    quote:
      "Gold Mind Business helped us reach students across the islands and the mainland. Our admissions enquiries are up 4x and the team handles every detail — from creative to follow-up automation.",
  },
  {
    name: "Tapati Dass",
    company: "Founder & Director, BRITECH IT Pvt. Ltd.",
    quote:
      "We needed serious B2B pipeline, not vanity metrics. Their performance marketing and funnel work turned our website into a real sales engine — we now get qualified discovery calls every week.",
  },
  {
    name: "Mohd Shahbaz Khan",
    company: "Director, 24x7 IMFS Pvt. Ltd.",
    quote:
      "In financial services, trust is everything. Their creative strategy and local SEO gave us a premium digital presence that is directly translating into more closed clients month after month.",
  },
  {
    name: "Gyanti Devi",
    company: "Director, REX Employment Consulting Services Pvt. Ltd.",
    quote:
      "Their WhatsApp automation and lead follow-up system have completely changed how we work with candidates and employers. Response times dropped, conversions doubled, and our team finally has breathing room.",
  },
];

export default function Testimonials() {
  const ref = useReveal();
  return (
    <section
      id="testimonials"
      ref={ref}
      data-testid="testimonials-section"
      className="py-16 sm:py-24 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 fade-up">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#B01116]">
            Over 60+ Businesses Transformed
          </h2>
          <p className="mt-5 text-base text-gray-600 leading-relaxed">
            Real results from real clients — here&apos;s what they say about
            working with Gold Mind Business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="gmb-card p-8 fade-up flex flex-col"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center justify-between">
                <Quote className="h-8 w-8 text-[#B01116]/50" strokeWidth={1.5} />
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star
                      key={idx}
                      className="h-4 w-4 text-[#FFC107] fill-[#FFC107]"
                      strokeWidth={1}
                    />
                  ))}
                </div>
              </div>
              <blockquote className="mt-5 text-base text-gray-600 leading-relaxed flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-gray-100">
                <div className="font-accent font-bold text-[#B01116]">{t.name}</div>
                <div className="text-xs text-gray-500 mt-1">{t.company}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
